module.exports = __webpack_public_path__ + "media/localization/arabic-8f6c076a.png";